import type { AnchorHTMLAttributes } from "react";

const INTERNAL_HOSTNAMES = new Set([
  "guardianservice.com",
  "www.guardianservice.com",
  "ulw.guardianservice.com",
  "test.guardianservice.com",
]);

function isExternalHref(href: string): boolean {
  if (!href || href.startsWith("/") || href.startsWith("#")) {
    return false;
  }

  if (href.startsWith("mailto:") || href.startsWith("tel:")) {
    return false;
  }

  try {
    const parsed = new URL(href, "https://www.guardianservice.com");
    if (!/^https?:$/.test(parsed.protocol)) {
      return false;
    }
    return !INTERNAL_HOSTNAMES.has(parsed.hostname.toLowerCase());
  } catch {
    return false;
  }
}

export default function MDXLink({
  href = "",
  target,
  rel,
  ...props
}: AnchorHTMLAttributes<HTMLAnchorElement>) {
  const external = isExternalHref(href);
  const relParts = new Set((rel || "").split(/\s+/).filter(Boolean));
  if (external) {
    relParts.add("noopener");
    relParts.add("noreferrer");
  }
  const secureRel = relParts.size ? Array.from(relParts).join(" ") : undefined;

  return (
    <a
      href={href}
      target={external ? "_blank" : target}
      rel={secureRel}
      {...props}
    />
  );
}
